<template>
  <div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th style="width:35%">Nazwa</th>
          <th style="width:35%">Maska</th>
          <th style="width:10%">Liczba sprzętów</th>
          <th style="width:20%" class="text-right">
            <b-btn size="sm" variant="outline-primary" @click="add = !add">Dodaj</b-btn>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-show="add">
          <td>
            <app-input :model="$schema.name"></app-input>
          </td>
          <td>
            <app-input :model="$schema.mask"></app-input>
          </td>
          <td></td>
          <td>
            <b-btn class="float-right ml-1" size="sm" variant="outline-warning" @click="resetForm">Anuluj</b-btn>
            <b-btn class="float-right" size="sm" variant="outline-primary" @click="saveType">Zapisz</b-btn>
          </td>
        </tr>
        <tr v-for="item in types" v-show="item.id !== $schema.$model.id" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.mask }}</td>
          <td>{{ item.equipments ? item.equipments.length : 0 }}</td>
          <td class="text-right">
            <b-dropdown size="sm" split @click="editType(item)" text="Edytuj" variant="outline-primary">
              <b-dropdown-item @click="deleteType(item.id)">Usuń</b-dropdown-item>
            </b-dropdown>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import formMixin from '@/mixins/formMixin';
import schema from '@/schemas/equipmentType.schema';
import { EquipmentTypeResource } from '@/resources/equipmentType.resource';

export default {
  mixins: [formMixin],
  schema,
  data() {
    return {
      types: [],
      add: false
    };
  },
  methods: {
    async getTypes() {
      try {
        this.types = await EquipmentTypeResource.list();
      } catch (error) {
        this.$notify({ text: 'Nie udało się pobrać typu wyposażenia', title: 'Błąd', type: 'error' });
        console.warn(error);
      }
    },
    async saveType() {
      if (this.$schema.$validateAll().length > 0) {
        return;
      }
      if (!this.$schema.$model.id) {
        await this.addType();
      } else {
        await this.updateType();
      }
    },
    async addType() {
      try {
        const newEquipment = await EquipmentTypeResource.add(this.$schema);
        this.$notify({ text: 'Pomyślnie dodano typ wyposażenia', title: 'Sukces', type: 'success' });
        this.types.push(newEquipment);
        this.resetForm();
      } catch (error) {
        this.$notify({ text: 'Nie udało się dodać typu wyposażenia', title: 'Błąd', type: 'error' });
        console.warn(error);
      }
    },
    async updateType() {
      try {
        const updatedEquipment = await EquipmentTypeResource.update(this.$schema);
        this.$set(this.types, this.types.findIndex(item => item.id === updatedEquipment.id), updatedEquipment);
        this.resetForm();
      } catch (error) {
        this.$notify({ text: 'Nie udało się edytować typu wyposażenia', title: 'Błąd', type: 'error' });
        console.warn(error);
      }
    },
    async deleteType(id) {
      try {
        await EquipmentTypeResource.delete(id);
        this.types.splice(this.types.findIndex(item => item.id === id), 1);
      } catch (error) {
        this.$notify({ text: 'Nie udało się usunąć typu wyposażenia', title: 'Błąd', type: 'error' });
        console.warn(error);
      }
    },
    editType(type) {
      this.add = true;
      this.$schema.$model.name = type.name;
      this.$schema.$model.mask = type.mask;
      this.$schema.$model.id = type.id;
    },
    resetForm() {
      this.add = false;
      this.$schema.$model.name = '';
      this.$schema.$model.mask = '';
      this.$schema.$model.id = null;
    }
  },
  beforeMount() {
    this.getTypes();
  }
};
</script>
